import _defineProperty from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/.github-runner/_work/dfh-corp-sites/dfh-corp-sites/node_modules/.pnpm/@babel+runtime@7.27.1/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createTransport } from '@sentry/core';
import { getNativeImplementation, clearCachedImplementation } from '@sentry-internal/browser-utils';

/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(options) {
  var nativeFetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getNativeImplementation('fetch');
  var pendingBodySize = 0;
  var pendingCount = 0;
  function makeRequest(_x) {
    return _makeRequest.apply(this, arguments);
  }
  function _makeRequest() {
    _makeRequest = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(request) {
      var requestSize, requestOptions, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            requestSize = request.body.length;
            pendingBodySize += requestSize;
            pendingCount++;
            requestOptions = _objectSpread({
              body: request.body,
              method: 'POST',
              referrerPolicy: 'strict-origin',
              headers: options.headers,
              // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
              // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
              // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
              // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
              // Gotchas:
              // - `keepalive` isn't supported by Firefox
              // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
              //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
              //   We will therefore only activate the flag when we're below that limit.
              // There is also a limit of requests that can be open at the same time, so we also limit this to 15
              // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
              keepalive: pendingBodySize <= 60000 && pendingCount < 15
            }, options.fetchOptions);
            _context.prev = 4;
            _context.next = 7;
            return nativeFetch(options.url, requestOptions);
          case 7:
            response = _context.sent;
            return _context.abrupt("return", {
              statusCode: response.status,
              headers: {
                'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                'retry-after': response.headers.get('Retry-After')
              }
            });
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](4);
            clearCachedImplementation('fetch');
            throw _context.t0;
          case 15:
            _context.prev = 15;
            pendingBodySize -= requestSize;
            pendingCount--;
            return _context.finish(15);
          case 19:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 11, 15, 19]]);
    }));
    return _makeRequest.apply(this, arguments);
  }
  return createTransport(options, makeRequest);
}
export { makeFetchTransport };